import Dto from "../../../../../service/Dto";

class Po2BulkMailerEntity extends Dto {

  listName = '';
  queueName = '';
  template = '';
  scheduledStartDateTime = '';
  mailTo = '';
  mailToDisplayText = '';
  testMailReceiver = '';
  testMailNumOfSendings = '';
  accountId = '';
  query = '';

  constructor(listName = '', queueName = '', template = '', scheduledStartDateTime = '', mailTo = '',
              mailToDisplayText = '', testMailReceiver = '', testMailNumOfSendings = '', accountId = '', query = '',
              _class = 'campaign\\module\\modules\\ustore\\v002\\utils\\Po2BulkMailerEntity') {

    super(_class);
    this.listName = listName;
    this.queueName = queueName;
    this.template = template;
    this.scheduledStartDateTime = scheduledStartDateTime;
    this.mailTo = mailTo;
    this.mailToDisplayText = mailToDisplayText;
    this.testMailReceiver = testMailReceiver;
    this.testMailNumOfSendings = testMailNumOfSendings;
    this.accountId = accountId;
    this.query = query;
  }

  getAccountId() {
    return this.accountId;
  }

  setAccountId(value) {
    this.accountId = value;
  }

  getListName() {
    return this.listName;
  }

  setListName(value) {
    this.listName = value;
  }

  getQueueName() {
    return this.queueName;
  }

  setQueueName(value) {
    this.queueName = value;
  }

  getTemplate() {
    return this.template;
  }

  setTemplate(value) {
    this.template = value;
  }

  getScheduledStartDateTime() {
    return this.scheduledStartDateTime;
  }

  setScheduledStartDateTime(value) {
    this.scheduledStartDateTime = value;
  }

  getMailTo() {
    return this.mailTo;
  }

  setMailTo(value) {
    this.mailTo = value;
  }

  getMailToDisplayText() {
    return this.mailToDisplayText;
  }

  setMailToDisplayText(value) {
    this.mailToDisplayText = value;
  }

  getTestMailReceiver() {
    return this.testMailReceiver;
  }

  setTestMailReceiver(value) {
    this.testMailReceiver = value;
  }

  getTestMailNumOfSendings() {
    return this.testMailNumOfSendings;
  }

  setTestMailNumOfSendings(value) {
    this.testMailNumOfSendings = value;
  }

  getQuery() {
    return this.query;
  }

  setQuery(value) {
    this.query = value;
  }
}

export default Po2BulkMailerEntity;
